export default __webpack_public_path__ + "static/media/tenPercentageThreshold.fd87a0d0.svg";